module.exports = __webpack_public_path__ + "static/media/SPR.18c75917.pdf";